import React, { useRef, useState } from "react";
import axios from "axios";
import apiUrl from "../Apiurl";
import stilePulsanti from "../interfaccia/stilePulsanti";

function dataLocale(data) {
  return `${data.getFullYear()}-${String(data.getMonth() + 1).padStart(2, "0")}-${String(data.getDate()).padStart(2, "0")}`;
}

function dateIniziali() {
  const oggi = new Date();
  const dal = new Date(oggi);
  dal.setDate(dal.getDate() - 2);
  return { dal: dataLocale(dal), al: dataLocale(oggi) };
}

function descriviNote(dati) {
  const note = [];
  if (dati.superati) note.push(`${dati.superati} esclusi perché superati da un job più recente.`);
  if (dati.nonRitentabili) note.push(`${dati.nonRitentabili} non ritentabili: checkpoint SFTP assente o rami bloccati.`);
  if (dati.oltreLimite) note.push(`${dati.oltreLimite} oltre il limite di 1000: rilancia il comando dopo questo giro.`);
  const finestra = dati.finestra;
  if (finestra?.aperta === false) {
    note.push(`Finestra notturna chiusa: gli invii partiranno dalle ${finestra.inizio}:00 (${finestra.timeZone}), nella finestra ${finestra.inizio}:00–${finestra.fine}:00.`);
  }
  return note.length ? `\n\n${note.join("\n")}` : "";
}

function RitentaErroriImmagini({ token, onCompletato, disabled = false }) {
  const [date, setDate] = useState(dateIniziali);
  const [inCorso, setInCorso] = useState(false);
  const richiestaAttiva = useRef(false);

  const ritenta = async () => {
    if (!token || disabled || richiestaAttiva.current) return;
    const { dal, al } = date;
    if (!dal || !al) {
      window.alert("Indica entrambe le date Dal e Al.");
      return;
    }
    if (al < dal) {
      window.alert("La data Al deve essere uguale o successiva alla data Dal.");
      return;
    }
    // Conta giorni di calendario, senza risentire dei cambi di ora legale.
    const giorni = (Date.parse(al) - Date.parse(dal)) / 86400000 + 1;
    if (!Number.isFinite(giorni) || giorni > 31) {
      window.alert("Seleziona un intervallo massimo di 31 giorni, estremi inclusi.");
      return;
    }

    richiestaAttiva.current = true;
    setInCorso(true);
    const chiamaApi = (anteprima) => axios.post(
      `${apiUrl}/moda/image-jobs/retry-errors`,
      { dal, al, anteprima },
      { headers: { Authorization: "Bearer " + token } },
    );
    try {
      const { data: anteprima } = await chiamaApi(true);
      const dati = anteprima.data;
      if (!dati.daRitentare) {
        window.alert(`Nessun job immagini in errore da ritentare dal ${dal} al ${al}.` + descriviNote(dati));
        return;
      }
      const siti = ["VIG", "BOT", "MODA"]
        .filter((sito) => dati.perSito?.[sito] > 0)
        .map((sito) => `${sito}: ${dati.perSito[sito]}`)
        .join(", ");
      if (!window.confirm(
        `Ritentare ${dati.daRitentare} job immagini in errore dal ${dal} al ${al}?\nSolo i rami falliti di ogni job saranno ritentati.` +
        (siti ? `\nJob per sito: ${siti}. Un job può avere più rami falliti.` : "") +
        descriviNote(dati),
      )) return;

      const { data: risposta } = await chiamaApi(false);
      const esito = risposta.data;
      const primoErrore = esito.errori?.[0];
      window.alert(
        `Accodati ${esito.accodati}, saltati ${esito.saltati}, errori ${esito.errori?.length || 0}.` +
        (primoErrore ? `\nPrimo errore: ${primoErrore.productCode || primoErrore.jobId}: ${primoErrore.errore}` : "") +
        descriviNote(esito),
      );
      await onCompletato();
    } catch (error) {
      window.alert("Ritentativo non riuscito: " + (error?.response?.data?.error || error?.message || "errore sconosciuto"));
    } finally {
      richiestaAttiva.current = false;
      setInCorso(false);
    }
  };

  return (
    <div className="pa2">
      <div className="flex flex-wrap items-end">
        {["dal", "al"].map((campo) => (
          <label key={campo} className="mr2 mb2">
            <span className="db f7 ttu tracked mb1">{campo === "dal" ? "Dal" : "Al"}</span>
            <input
              type="date"
              className="pa2 input-reset ba b--black-20 sfondoBiancoTema"
              value={date[campo]}
              disabled={inCorso}
              onChange={(event) => setDate({ ...date, [campo]: event.target.value })}
            />
          </label>
        ))}
        <button
          type="button"
          className={`${stilePulsanti.buttonClassesGreen} mb2`}
          disabled={!token || disabled || inCorso}
          onClick={ritenta}
        >
          {inCorso ? "Ritento..." : "Ritenta errori"}
        </button>
      </div>
      <div className="f7">Solo i rami falliti, nel periodo indicato. Invii nella finestra notturna degli import massivi.</div>
    </div>
  );
}

export default RitentaErroriImmagini;
